import apiClient from "../services/apiClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function submitContactMessage(payload) {
  const { data } = await apiClient.post("/api/contact/messages", payload);
  return unwrapApiResponse({ data });
}
